var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"no-network"},[_c('div',{staticClass:"offline"},[_c('img',{attrs:{"src":require("@/assets/detail/offline.png")}}),_c('span',[_vm._v(_vm._s(_vm.showText ? _vm.showText : '项目不存在或已下架'))])])])])}
var staticRenderFns = []

export { render, staticRenderFns }